"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiffOperation = void 0;
var DiffOperation;
(function (DiffOperation) {
    DiffOperation["Added"] = "added";
    DiffOperation["Removed"] = "removed";
    DiffOperation["Updated"] = "updated";
})(DiffOperation = exports.DiffOperation || (exports.DiffOperation = {}));
